import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { CartoesOpenfinanceResponse } from '../../responses/integracao-financas-banco/cartoes-openfinance.response';
import { ContasConectadasResponse } from '../../responses/financas/contas-conectadas.response';
import { StatusExtratoContasResponse } from '../../responses/integracao-financas-banco/status-extrato-contas.response';
import { IntegracaoStatusResponse } from '../../responses/integracao-financas-banco/integracao-status.response';

@Injectable({
    providedIn: 'root',
})
export class ExtratoService extends CommonService {
    private readonly apiUrl = `${environment.urlApiIntegracaoFinancasBanco}Extrato/`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getCartoesOpenfinance(idContaFinanceira: number): Observable<CartoesOpenfinanceResponse> {
        return this.httpClient
            .get<CartoesOpenfinanceResponse>(
                `${this.apiUrl}cartoes-openfinance/${idContaFinanceira}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public getContasConectadas(): Observable<ContasConectadasResponse> {
        return this.httpClient
            .get<ContasConectadasResponse>(
                this.apiUrl + 'contas-conectadas',
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public getStatusExtratoContas(listIdContaFinanceira: number[]): Observable<StatusExtratoContasResponse> {
        return this.httpClient
            .post<StatusExtratoContasResponse>(
                this.apiUrl + 'status-extrato-contas',
                listIdContaFinanceira,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public getIntegracaoStatus(idContaFinanceira: number): Observable<IntegracaoStatusResponse> {
        return this.httpClient
            .get<IntegracaoStatusResponse>(
                `${this.apiUrl}integracao-status/${idContaFinanceira}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }
}
